import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { closeDialog, DialogIdentifiers, openDialog } from '@shared/store/dialog.duck';
import Dialog from "@shared/ui/molecules/Dialog";
import DialogHeader from '@shared/dialogs/DialogHeader';
import { BodySmall } from "@shared/ui/atoms/fonts/Body";
import { selectCurrentUser, updateCurrentUser } from '@shared/store/auth.duck';
import { updateOutlookSyncState } from '@features/settings/services/UserService';
import Colours from "@shared/ui/atoms/Colours";
import { BorderlessButton } from "@shared/ui/atoms/buttons/BorderlessButton";
import { PrimaryButton } from "@shared/ui/atoms/buttons/PrimaryButton";
import { isInTeams } from '@shared/utils/TeamsUtils';
import { Center } from "@shared/ui/atoms/StructuralLayout";
import { useTranslation } from "react-i18next";
import { requestCalendarAccess } from '@shared/auth/authMachine.duck';

export function AzureCalendarSyncDisabledDialog(_props: Props) {
  const user = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const {t} = useTranslation();

  useEffect(() => {
    if (isInTeams()) {
      dispatch(openDialog(DialogIdentifiers.AzurePermissionsRequired));
    }
  }, [dispatch])

  const tryAgain = async () => {
    setIsLoading(true);
    try {
      await updateOutlookSyncState(true);
      try {
        // The user just clicked "yes" in this dialog — that IS the in-app
        // confirmation, so allow direct escalation to Microsoft's consent UI
        // rather than bouncing them through PermissionNeededDialog as well.
        await (dispatch(requestCalendarAccess({ source: 'manual', interactiveConfirmed: true })) as any).unwrap();
      } catch (e: any) {
        console.error('Failed to get permissions', e);
        await updateOutlookSyncState(false);
        dispatch(openDialog(DialogIdentifiers.AzureCalendarSyncDisabledDialog));
      }
      setIsLoading(false);
      dispatch(closeDialog())
    } finally {
      setIsLoading(false);
    }
  }

  const close = async () => {
    setIsLoading(true);

    try {
      if (user) {
        await updateOutlookSyncState(false)
        dispatch(updateCurrentUser(true));
      }
    } finally {
      setIsLoading(false);
      dispatch(closeDialog())
    }
  }

  return (
    <Dialog isOpen={true} onClose={close} showLogo={true}>
      <DialogHeader title="dialog-headers.sync-to-outlook" />
      <Center>
        <img src="/assets/images/CalendarSync.svg"
             style={{width: '90%'}}
             alt={"Calendar sync"} />
      </Center>

      <PrimaryButton click={tryAgain}
                     text={'sync-to-outlook-dialog.yes'}
                     fullWidth={true}
                     style={{marginBottom: 16}}
                     disabled={isLoading} />

      <BorderlessButton click={close}
                        text={'sync-to-outlook-dialog.no'}
                        fullWidth={true}
                        style={{marginBottom: 16}}
                        disabled={isLoading} />

      <BodySmall colour={Colours.darkGrey} style={{marginBottom: 32}}>{t('sync-to-outlook-dialog.message')}</BodySmall>
    </Dialog>
  )
}

interface Props {
}
